import React from 'react';
import { BenefitSection, BenefitCard } from "@/.storyblok/types/319751/storyblok-components";
import { SbBlokData, storyblokEditable } from "@storyblok/react";
import { renderRichText } from '@/lib/richText';
import Link from 'next/link';
import Image from "next/image";

const BenefitSectionComponent = ({ blok }: { blok: BenefitSection & SbBlokData }) => {
  if (!blok) return null;

  const defaultBenefits = blok.benefits?.filter((benefit: BenefitCard) => benefit.type !== "red_icon") || [];
  const redIconBenefits = blok.benefits?.filter((benefit: BenefitCard) => benefit.type === "red_icon") || [];

  return (
    <div className="bg-light" {...storyblokEditable(blok)}>
      <div className="container text-center text-md-start py-4 py-md-5">
        {blok.title && (
          <h2 className="text-dark text-center mb-4">{blok.title}</h2>
        )}
        {blok.description && (
          <p className="lead col-12 mx-auto text-center mb-5">{blok.description}</p>
        )}

        {defaultBenefits.length > 0 && (
          <ul className="row list-unstyled g-4 scroll-trigger bulletproof-checklist mb-5 on">
            {defaultBenefits.map((benefit) => (
              <li key={benefit._uid} className="col-24 col-md-12 col-lg-8" {...storyblokEditable(benefit as SbBlokData)}>
                <div className="card card-lighter card-green-check h-100 p-3">
                  <h3 className="h5 mb-1">{benefit.title}</h3>
                  {benefit.description && (
                    <div
                      className="mb-o"
                      dangerouslySetInnerHTML={{ __html: renderRichText(benefit.description) }}
                    />
                  )}
                </div>
              </li>
            ))}
          </ul>
        )}

        {redIconBenefits.length > 0 && (
          <div className="row justify-content-center g-lg-4">
            {redIconBenefits.map((benefit) => (
              <div key={benefit._uid} className="col-24 col-lg-12 mb-3" {...storyblokEditable(benefit as SbBlokData)}>
                <div className="card card-lighter h-100 p-4 text-center">
                  {benefit.icon?.filename && (
                    <Image
                      alt={benefit.icon.alt || ""}
                      className="img-fluid mb-2 mx-auto"
                      src={benefit.icon.filename}
                      width={120}
                      height={120}
                      sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                      loading="lazy"
                      quality={75}
                    />
                  )}
                  <h3 className="mt-2">{benefit.title}</h3>
                  {benefit.description && (
                    <div
                      className="mb-o"
                      dangerouslySetInnerHTML={{ __html: renderRichText(benefit.description) }}
                    />
                  )}
                </div>
              </div>
            ))}
          </div>
        )}

        {blok.cta_button && blok.cta_button_link && (
          <div className="text-center container mt-5">
            <Link
              href={blok.cta_button_link.url || '#'}
              className="btn btn-lg btn-primary js-cta-btn"
            >
              {blok.cta_button}
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};

export default BenefitSectionComponent;